export default __webpack_public_path__ + "static/media/website-1.c616e62f.jpg";